import { render, staticRenderFns } from "./IVDiagram.vue?vue&type=template&id=3fee11c0&scoped=true&"
import script from "./IVDiagram.vue?vue&type=script&lang=js&"
export * from "./IVDiagram.vue?vue&type=script&lang=js&"
import style0 from "./IVDiagram.vue?vue&type=style&index=0&id=3fee11c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee11c0",
  null
  
)

export default component.exports